import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker as MUIDatepicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { DatePickerProps } from './type';

export function DatePicker({
    label,
    maxDate = new Date(),
    minDate = null,
    onClose,
    onError,
    setValue,
    value,
}: DatePickerProps): JSX.Element {
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <MUIDatepicker
                label={label}
                maxDate={maxDate}
                minDate={minDate}
                onChange={(newValue) => setValue(newValue)}
                onClose={onClose}
                onError={onError}
                value={value}
            />
        </LocalizationProvider>
    );
}
